<template>
<table class="user-table">
  <thead>
    <tr>
      <th></th>
      <th>Usuario</th>
      <th>Nombre completo</th>
      <th>Email</th>
    </tr>
  </thead>
  <tbody>
    <tr v-for="user in users" :key="user.id">
      <td class="user-table__btn-td">
        <a
          href=""
          class="user-table__btn"
          @click.prevent="$emit('goToUserEdit', user)"
          v-tooltip.top-center="'Editar'"
        >
          <font-awesome-icon icon="pen" />
        </a>
      </td>
      <td>{{ user.username }}</td>
      <td>{{ user.name }}</td>
      <td>{{ user.email }}</td>
    </tr>
  </tbody>
</table>
</template>

<script>
export default {
  name: 'userTable',

  computed: {
    users() {
      return this.$store.state.user.users
    }
  }
}
</script>
